import React, { useState } from 'react';

const API = 'http://localhost:8000/api/v1';

function Counterparty() {
  const [inn, setInn] = useState('');
  const [result, setResult] = useState(null);
  const [history, setHistory] = useState(() => {
    const saved = localStorage.getItem('khepri_counterparty_history');
    return saved ? JSON.parse(saved) : [];
  });

  const check = async (e) => {
    e.preventDefault();
    if (!inn.trim()) return;
    const res = await fetch(API + '/tax/check_counterparty?inn=' + inn);
    const data = await res.json();
    setResult(data);

    const newRecord = { inn, status: data.status, date: new Date().toLocaleString('ru-RU') };
    const updated = [newRecord, ...history.filter(h => h.inn !== inn)].slice(0, 10);
    setHistory(updated);
    localStorage.setItem('khepri_counterparty_history', JSON.stringify(updated));
  };

  const clearHistory = () => {
    setHistory([]);
    localStorage.removeItem('khepri_counterparty_history');
  };

  const getStatusColor = (status) => {
    if (status === 'critical') return '#EF4444';
    if (status === 'high') return '#F59E0B';
    return '#10B981';
  };

  return (
    <div>
      <h2>Проверка контрагента</h2>
      <form onSubmit={check} style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <input value={inn} onChange={e => setInn(e.target.value)} placeholder="ИНН (10 цифр)" style={{ flex: 1, padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }} />
        <button type="submit" style={{ padding: '10px 20px', background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Проверить</button>
      </form>

      {result && (
        <div style={{ marginTop: 16, padding: 16, background: '#1E293B', borderRadius: 8 }}>
          <p>ИНН: {result.inn}</p>
          <p>Статус: <span style={{ color: getStatusColor(result.status), fontWeight: 600 }}>{result.status}</span></p>
          {(result.risks || []).map((r, i) => <p key={i} style={{ color: '#F59E0B' }}>[{r.severity}] {r.description}</p>)}
        </div>
      )}

      {history.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <h3>📋 История проверок</h3>
            <button onClick={clearHistory} style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: 12, textDecoration: 'underline' }}>
              Очистить
            </button>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
                <th style={{ padding: 8 }}>ИНН</th>
                <th style={{ padding: 8 }}>Статус</th>
                <th style={{ padding: 8 }}>Дата проверки</th>
              </tr>
            </thead>
            <tbody>
              {history.map((h, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #334155', cursor: 'pointer' }} onClick={() => setInn(h.inn)}>
                  <td style={{ padding: 8 }}>{h.inn}</td>
                  <td style={{ padding: 8 }}>
                    <span style={{ color: getStatusColor(h.status), fontWeight: 600 }}>{h.status}</span>
                  </td>
                  <td style={{ padding: 8, color: '#94A3B8' }}>{h.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Counterparty;